<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>答复审核办理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-coin" @click.native="formSubmit(0)" :disabled="(!data.form.message && data.form.selectType == 2) ||
          data.lastNode.isSucces
          ">保存</el-button>
        <el-button type="info" icon="el-icon-position" @click.native="formSubmit(1)" :disabled="(!data.form.message && data.form.selectType == 2) ||
          data.lastNode.isSucces
          ">提交</el-button>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser()">舆情来源</el-button>
        <el-button type="info" icon="el-icon-arrow-left" @click.native="formReturn()">返 回</el-button></el-button-group>
    </el-header>
    <el-main>
      <el-tabs type="card" :tab-position="tabPosition" @tab-click="tabclick" v-model="activeTabName">
        <!-- 舆情详情 -->
        <el-tab-pane name="tabFirst">
          <span slot="label"><i class="el-icon-date"></i> 工单详情</span>
          <el-form :model="data.pst" status-icon label-width="100px">
            <el-form-item label="录入人" prop="userName">
              <el-input v-model="data.pst.userName" disabled />
            </el-form-item>
            <el-form-item label="舆情类别" prop="pstType">
              <el-input v-model="data.pstTypeName" disabled />
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input v-model="data.pst.title" disabled />
            </el-form-item>
            <el-form-item label="发贴人" prop="name">
              <el-input v-model="data.pst.name" disabled />
            </el-form-item>
            <el-form-item label="发贴时间" prop="postingTime">
              <el-input v-model="data.pst.postingTime" disabled />
            </el-form-item>
            <el-form-item label="来源" prop="pstSource">
              <el-input v-model="data.pst.pstSource" disabled />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input type="textarea" :rows="10" v-model="data.pst.pstContent" disabled />
            </el-form-item>
            <el-form-item label="状态" prop="statusName">
              <el-input v-model="data.statusName" disabled />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 办理流程 -->
        <el-tab-pane v-for="node in data.nodes" :key="node.id" :name="'tab' + node.id">
          <span slot="label"><i :class="pstApi.getStatusIcon(node.status)"></i>
            {{ pstApi.getNodeTitle(node.status) }}</span>
          <el-form :model="node" status-icon label-width="100px">
            <el-form-item label="办理单位">
              <el-input v-model="node.unitName" disabled />
            </el-form-item>
            <el-form-item label="办理人">
              <el-input v-model="node.userName" disabled />
            </el-form-item>
            <el-form-item label="转办单位" v-if="node.status == 1">
              <el-input v-model="node.transferUnitName" disabled />
            </el-form-item>
            <el-form-item label="答复信息" v-if="node.nodeContent">
              <el-input type="textarea" :rows="2" v-model="node.nodeContent" disabled />
            </el-form-item>
            <el-form-item label="提交信息" v-if="node.nodeMessage">
              <el-input type="textarea" :rows="node.status == 2 ? 15 : 2" v-model="node.nodeMessage" disabled />
            </el-form-item>
            <el-form-item :label="pstApi.getTimeTitle(node.status)">
              <el-input :value="node.lastTime
                ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                : ''
                " disabled />
            </el-form-item>
            <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
              <el-card class="box-card">
                <upload :nodeId="node.id" :disabled="true" />
              </el-card>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 答复审核 -->
        <el-tab-pane :key="data.nodes.length + 1" name="tabLast">
          <span slot="label"><i class="el-icon-position"></i>
            <font color="green"> 答复审核 </font>
          </span>
          <el-form :model="data.lastNode" ref="pstRef" status-icon label-width="100px">
            <el-form-item label="办理方式">
              <el-radio-group v-model="data.form.selectType">
                <el-radio :label="4">审核通过</el-radio>
                <el-radio :label="2">重新答复</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="工单标题">
              <el-input v-model="data.pst.title" disabled />
            </el-form-item>
            <el-form-item label="回复留言" v-if="data.form.selectType == 2">
              <el-input type="textarea" :rows="3" v-model="data.form.message" :disabled="data.lastNode.isSucces" />
            </el-form-item>
            <el-form-item label="答复信息" v-if="data.replyNode">
              <el-input type="textarea" :rows="10" v-model="data.replyNode.nodeMessage" disabled />
              <div v-if="data.form.selectType == 4" style="text-align: center;margin-top: 10px;">
                <el-button-group>
                  <el-Button type="info" :disabled="ai.disable" @click="callDeepSeek">
                    AI审稿
                  </el-Button>
                  <el-Button type="info" :disabled="ai.disable || ai.isAudit == false" @click="ai.isAudit = false">
                    关闭建议
                  </el-Button>
                </el-button-group>
              </div>
            </el-form-item>
            <el-form-item v-if="data.form.selectType == 4 && ai.isAudit == true" label="AI建议">
              <el-input v-model="ai.result" type="textarea" :rows="10" disabled />
            </el-form-item>
            <el-form-item label="佐证材料" v-if="data.replyNode && data.replyNode.uploadCount > 0">
              <el-card class="box-card">
                <upload :nodeId="data.replyNode.id" :disabled="true" />
              </el-card>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("答复审核");
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      activeTabName: "tabLast",
      ai: {
        disable: false,
        isAudit: false,
        result: ''
      },
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
        },
        nodes: [],
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 0,
          status: 4,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        replyNode: "",
        form: {
          selectType: 4,
          message: "",
        },
      },
    };
  },
  methods: {
    callDeepSeek() {
      if (this.data.replyNode.nodeMessage == '') {
        this.$toast("答复内容不能为空");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'AI正在为您审稿，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.ai.disable = true
      this.pstApi.callDeepSeek_Text(this.data.replyNode.nodeMessage)
        .then((res) => {
          loading.close();
          this.ai.result = res.data
          this.ai.isAudit = true
          this.ai.disable = false
        })
        .catch((err) => {
          loading.close();
          this.$toast("Ai审稿失败");
          this.ai.disable = false
        })
    },
    //读取舆情信息
    getPst() {
      let pstId = this.data.pst.id;
      this.pstApi
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          this.data.pst = data;
          var lastNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          if (lastNodes.length > 0) {
            this.data.lastNode = lastNodes[0];
          }

          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.message = this.data.lastNode.nodeMessage;
          //
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;
          //
          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          var replyNodes = data.nodeInfos.filter((node) => node.status == 2);
          if (replyNodes.length > 0) {
            this.data.replyNode = replyNodes[0];
          }
          //
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let message = this.data.form.message;
      let selectType = this.data.form.selectType;
      var submitType = 0;
      if (selectType == 2) {
        submitType = -1;
      } else if (selectType == 4 && buttonType == 1) {
        submitType = 1;
      }
      if (message == "" && selectType == 2) {
        this.$toast("请填写提交信息");
        return;
      }
      if (selectType == 4) {
        message = "审核通过";
      }

      this.pstApi
        .replyPstAudit(pstId, message, submitType)
        .then((res) => {
          if (submitType) {
            this.$toast("提交成功");
            this.formReturn();
          } else {
            this.$toast("保存成功");
            this.getPst();
          }
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
    tabclick(tab) {
      this.tabIndex = tab.index;
      //console.log(tab.name)
      if (this.tabIndex > 0) {
        this.data.currNode = this.data.nodes[this.tabIndex - 1];
      } else {
        this.data.currNode = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #FFF;
  border-color: #E4E7ED;
  color: #031944;
  cursor: auto;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #FFF;
  border-color: #E4E7ED;
  color: #031944;
  cursor: auto;
}
</style>